var map = {
	"./images/student-score-100p.png": 350,
	"./images/student-score-200p.png": 351,
	"./images/student-score-20p.png": 352,
	"./images/student-score-300p.png": 353,
	"./images/student-score-50p.png": 354,
	"./images/student-score-bg.jpg": 355,
	"./images/student-score-end.png": 356,
	"./images/student-score-hall.png": 357,
	"./images/student-score-hor-line.png": 358,
	"./images/student-score-losebox.png": 359,
	"./images/student-score-matching.png": 360,
	"./images/student-score-next.png": 361,
	"./images/student-score-point-bg.png": 362,
	"./images/student-score-prev.png": 363,
	"./images/student-score-root-bg.jpg": 364,
	"./images/student-score-scorebox.png": 365,
	"./images/student-score-side.png": 366,
	"./images/student-score-star.png": 367,
	"./images/student-score-top.png": 368,
	"./images/student-score-ver-line.png": 369,
	"./images/student-score-winbox.png": 370
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 349;